// import dei microservizi
import logs from './logs';
import auth from './auth';
import general from './general';

export default {
    logs,
    auth,
    general
};